<script>
    import listReportingSearch from './list-reporting-search.vue';
    import listReportingActions from './list-reporting-actions.vue';
    import listReportingTable from './list-reporting-table.vue';
    import listReportingFilter from './list-reporting-filter.vue';
    import listReportingFilterModal from './list-reporting-filter-modal.vue';
    import listReportingColumnPresetModal from './list-reporting-column-preset-modal.vue';
    import toaster from "../common/toaster";
    import fixAriaTag from "./searchBarWorkaround";

    export default {
        components: {
            listReportingSearch,
            listReportingActions,
            listReportingTable,
            listReportingFilter,
            listReportingFilterModal,
            listReportingColumnPresetModal
        },
        data() {
            return {
                t_filter_load_error: Lang.langGet("Failed to load filter."),
                t_column_load_error: Lang.langGet("Failed to load Column Presets."),
                existing_filters: [],
                own_filters: [],
                existing_columns: [],
                from: '',
                to: '',
                filter_from: '',
                filter_to: '',
                search: '',
                groups: [],
                locations: [],
                action_visibility: false
            }
        },
        methods: {
            loadFilter: function () {
                axios.post('/system/reporting/list-filter', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.existing_filters = response.data.data.existing;
                    this.own_filters = response.data.data.own;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_filter_load_error);
                });
            },
            loadColumns: function () {
                axios.post('/system/reporting/list-column', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.existing_columns = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_column_load_error);
                });
            }
        },
        mounted() {
            this.loadFilter();
            this.loadColumns();

            EaseEventBus.listen('updateExistingFilters', () => {
                this.loadFilter();
            });

            EaseEventBus.listen('updateExistingColumnPresets', () => {
                this.loadColumns();
            });
            EaseEventBus.listen('updateTable', (data) => {
                if ((data == null) || (data.filter<=0)) {
                    this.filter_from = '';
                    this.filter_to = '';
                }
            });

            fixAriaTag($(this.$el));
        }
    }
</script>
